 $(document).ready(function() {

   // Swatch change
    $('input[type="radio"].swatch2-input').change(function() {
      if ($(this).is(':checked')) {
        let selectedColor = $(this).siblings('.swatch-2-tooltip').text();
        $('.swatch-variant').text(selectedColor);
      }
    });

    // Select 2
    $(".select-swatch").select2({
       templateResult: function(option) {
        if (!option.id) {
          return option.text;
        }
        let imgUrl = $(option.element).data('image_url');
         if(imgUrl != " "){
          return $('<span><img src="' + imgUrl + '" alt="' + option.text + '" /> ' + option.text + '</span>');
         }else{
           return $('<span class="select-result-text">' + option.text + '</span>');
         }
      },
      templateSelection: function(option) {
        if (!option.id) {
          return option.text;
        }
        let imgUrl = $(option.element).data('image_url');
         if(imgUrl != " "){
          return $('<span><img src="' + imgUrl + '" alt="' + option.text + '" /> ' + option.text + '</span>');
         }else{
           return $('<span class="select-result-text">' + option.text + '</span>');
         }
      }
    });
});